// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    color: #fbfef9;
    /* Light text for readability */
    font-family: "system-ui", Courier, monospace;
    /* Monospace font for a terminal-like feel */
    margin: 0;
    padding: 0;
}

p{
    margin: 0;
}

.logo-container {
    width: 15%;
    padding: 1rem;
}

.chat-container li, .chat-container ul, .chat-container ol{
    line-height: 1;
}

.chat-header {
    display: grid;
    grid-auto-flow: column;
    /* Header layout with title and status indicator */
    margin-bottom: 5px;
}

.chat-header b {
    color: #ffffff;
    margin-left: -40px;
    /* Offset title to balance the layout */
}

.connection-status {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    /* Circle indicator */
    background-color: #d32f2f;
    /* Default: Red (offline) */
    border: 2px solid #ffffff;
    transition: background-color 0.3s ease;
    /* Smooth status change */
    margin-top: 3px;
}

.connection-status.online {
    background-color: #66bb6a;
    /* Green (online) */
}

.connection-status.offline {
    background-color: #d32f2f;
    /* Red (offline) */
}

.chat-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
}

/* The focused-report card flips up from beneath the input when a report is
   selected (transform-origin is its bottom edge, adjacent to the input top). */
.report-flip-card {
    animation: reportFlipUp 360ms cubic-bezier(0.22, 1, 0.36, 1);
}

@keyframes reportFlipUp {
    from {
        transform: rotateX(-90deg);
        opacity: 0;
    }
    to {
        transform: rotateX(0deg);
        opacity: 1;
    }
}

.messages {
    display: flex;
    flex-direction: column;
    flex: 1 1;
    overflow-y: auto;
    /* Document layout: turns are full-bleed rows carrying their own background,
       so the list has no horizontal padding (each turn centers its own column). */
    padding: 0;
    scrollbar-width: none;
    direction: ltr; /* keep row layout stable regardless of global RTL */
    /* Fade messages out as they reach the input so text dissolves behind it
       instead of being sharply cut off. Masks to transparent, so it matches
       whatever background sits behind the chat. */
    mask-image: linear-gradient(to bottom, #000 calc(100% - 32px), transparent 100%);
}

.messages::-webkit-scrollbar {
    display: none;
}

.messages::-webkit-scrollbar-track {
    background: transparent;
}

.messages::-webkit-scrollbar-thumb {
    border-radius: 10px;
    border: 2px solid transparent;
}

.messages::-webkit-scrollbar-thumb:hover {
    background-color: transparent;
}

.message {
    display: inline-block;
    max-width: 80%;
    /* Prevent messages from stretching too wide */
    padding: 10px;
    border-radius: 10px;
    border: 2px solid #0e79b2;
    /* Consistent border color */
    color: #fbfef9;
    /* Light text for readability */
    font-size: 14px;
    margin-bottom: 10px;
    word-wrap: break-word;
    /* Allow messages to wrap */
    white-space: pre-wrap;
    /* Preserve newlines */
}

.message.thinking {
  opacity: 0.75;
  cursor: default !important;
  pointer-events: none;
}

.message.user {
    align-self: flex-end;
    /* Align user messages to the right */
    background: #0d0b0b;
    /* Dark background */
}

.message.bot {
    align-self: flex-start;
    /* Align bot messages to the left */
    background: #0d0b0b;
    /* Dark background */
}

.chat-form {
    display: flex;
    border-top: 2px solid #0e79b2;
    /* Border to separate input from messages */
}

.chat-form textarea {
    flex: 1 1;
    padding: 10px;
    border: none;
    border-radius: 0;
    background: #2c2c2c;
    /* Darker background for input */
    color: #fbfef9;
    /* Light text */
    font-size: 14px;
    font-family: "system-ui", Courier, monospace;
    /* Monospace font for input */
    resize: none;
    /* Disable manual resizing */
    height: 50px;
    line-height: 1.4;
}

.chat-form button {
    padding: 10px;
    background: #0e79b2;
    /* Button color matching the theme */
    color: #fbfef9;
    border: none;
    cursor: pointer;
    /* Pointer cursor on hover */
    font-size: 14px;
    transition: background 0.3s;
    /* Smooth hover effect */
}

.chat-form button:hover {
    background: #0c5a8a;
    /* Darker shade on hover */
}


/* General Table Styling */
table {
    width: 100%;
    border-collapse: collapse;
    font-family: Arial, sans-serif;
    margin: 20px 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    overflow: hidden;
}


table thead th {
    padding: 12px;
    text-align: left;
    font-weight: 600;
    border-bottom: 2px solid #ddd;
}

/* Table Body */
table tbody td {
    padding: 10px 12px;
    border-bottom: 1px solid #eee;
}



`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,+BAA+B;IAC/B,4CAA4C;IAC5C,4CAA4C;IAC5C,SAAS;IACT,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,2BAA2B;IAC3B,yBAAyB;IACzB,sCAAsC;IACtC,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;+EAC+E;AAC/E;IACI,4DAA4D;AAChE;;AAEA;IACI;QACI,0BAA0B;QAC1B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAO;IACP,gBAAgB;IAChB;kFAC8E;IAC9E,UAAU;IACV,qBAAqB;IACrB,cAAc,EAAE,oDAAoD;IACpE;;kDAE8C;IAE9C,gFAAgF;AACpF;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,8CAA8C;IAC9C,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,4BAA4B;IAC5B,cAAc;IACd,+BAA+B;IAC/B,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;IACI,oBAAoB;IACpB,qCAAqC;IACrC,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,mCAAmC;IACnC,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,2CAA2C;AAC/C;;AAEA;IACI,SAAO;IACP,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,cAAc;IACd,eAAe;IACf,eAAe;IACf,4CAA4C;IAC5C,6BAA6B;IAC7B,YAAY;IACZ,4BAA4B;IAC5B,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,cAAc;IACd,YAAY;IACZ,eAAe;IACf,4BAA4B;IAC5B,eAAe;IACf,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;AAC9B;;;AAGA,0BAA0B;AAC1B;IACI,WAAW;IACX,yBAAyB;IACzB,8BAA8B;IAC9B,cAAc;IACd,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,6BAA6B;AACjC","sourcesContent":["body {\n    color: #fbfef9;\n    /* Light text for readability */\n    font-family: \"system-ui\", Courier, monospace;\n    /* Monospace font for a terminal-like feel */\n    margin: 0;\n    padding: 0;\n}\n\np{\n    margin: 0;\n}\n\n.logo-container {\n    width: 15%;\n    padding: 1rem;\n}\n\n.chat-container li, .chat-container ul, .chat-container ol{\n    line-height: 1;\n}\n\n.chat-header {\n    display: grid;\n    grid-auto-flow: column;\n    /* Header layout with title and status indicator */\n    margin-bottom: 5px;\n}\n\n.chat-header b {\n    color: #ffffff;\n    margin-left: -40px;\n    /* Offset title to balance the layout */\n}\n\n.connection-status {\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    /* Circle indicator */\n    background-color: #d32f2f;\n    /* Default: Red (offline) */\n    border: 2px solid #ffffff;\n    transition: background-color 0.3s ease;\n    /* Smooth status change */\n    margin-top: 3px;\n}\n\n.connection-status.online {\n    background-color: #66bb6a;\n    /* Green (online) */\n}\n\n.connection-status.offline {\n    background-color: #d32f2f;\n    /* Red (offline) */\n}\n\n.chat-container {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    overflow: hidden;\n}\n\n/* The focused-report card flips up from beneath the input when a report is\n   selected (transform-origin is its bottom edge, adjacent to the input top). */\n.report-flip-card {\n    animation: reportFlipUp 360ms cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n@keyframes reportFlipUp {\n    from {\n        transform: rotateX(-90deg);\n        opacity: 0;\n    }\n    to {\n        transform: rotateX(0deg);\n        opacity: 1;\n    }\n}\n\n.messages {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    overflow-y: auto;\n    /* Document layout: turns are full-bleed rows carrying their own background,\n       so the list has no horizontal padding (each turn centers its own column). */\n    padding: 0;\n    scrollbar-width: none;\n    direction: ltr; /* keep row layout stable regardless of global RTL */\n    /* Fade messages out as they reach the input so text dissolves behind it\n       instead of being sharply cut off. Masks to transparent, so it matches\n       whatever background sits behind the chat. */\n    -webkit-mask-image: linear-gradient(to bottom, #000 calc(100% - 32px), transparent 100%);\n    mask-image: linear-gradient(to bottom, #000 calc(100% - 32px), transparent 100%);\n}\n\n.messages::-webkit-scrollbar {\n    display: none;\n}\n\n.messages::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.messages::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n    border: 2px solid transparent;\n}\n\n.messages::-webkit-scrollbar-thumb:hover {\n    background-color: transparent;\n}\n\n.message {\n    display: inline-block;\n    max-width: 80%;\n    /* Prevent messages from stretching too wide */\n    padding: 10px;\n    border-radius: 10px;\n    border: 2px solid #0e79b2;\n    /* Consistent border color */\n    color: #fbfef9;\n    /* Light text for readability */\n    font-size: 14px;\n    margin-bottom: 10px;\n    word-wrap: break-word;\n    /* Allow messages to wrap */\n    white-space: pre-wrap;\n    /* Preserve newlines */\n}\n\n.message.thinking {\n  opacity: 0.75;\n  cursor: default !important;\n  pointer-events: none;\n}\n\n.message.user {\n    align-self: flex-end;\n    /* Align user messages to the right */\n    background: #0d0b0b;\n    /* Dark background */\n}\n\n.message.bot {\n    align-self: flex-start;\n    /* Align bot messages to the left */\n    background: #0d0b0b;\n    /* Dark background */\n}\n\n.chat-form {\n    display: flex;\n    border-top: 2px solid #0e79b2;\n    /* Border to separate input from messages */\n}\n\n.chat-form textarea {\n    flex: 1;\n    padding: 10px;\n    border: none;\n    border-radius: 0;\n    background: #2c2c2c;\n    /* Darker background for input */\n    color: #fbfef9;\n    /* Light text */\n    font-size: 14px;\n    font-family: \"system-ui\", Courier, monospace;\n    /* Monospace font for input */\n    resize: none;\n    /* Disable manual resizing */\n    height: 50px;\n    line-height: 1.4;\n}\n\n.chat-form button {\n    padding: 10px;\n    background: #0e79b2;\n    /* Button color matching the theme */\n    color: #fbfef9;\n    border: none;\n    cursor: pointer;\n    /* Pointer cursor on hover */\n    font-size: 14px;\n    transition: background 0.3s;\n    /* Smooth hover effect */\n}\n\n.chat-form button:hover {\n    background: #0c5a8a;\n    /* Darker shade on hover */\n}\n\n\n/* General Table Styling */\ntable {\n    width: 100%;\n    border-collapse: collapse;\n    font-family: Arial, sans-serif;\n    margin: 20px 0;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n\ntable thead th {\n    padding: 12px;\n    text-align: left;\n    font-weight: 600;\n    border-bottom: 2px solid #ddd;\n}\n\n/* Table Body */\ntable tbody td {\n    padding: 10px 12px;\n    border-bottom: 1px solid #eee;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
